import { createStyles, makeStyles } from '@material-ui/core';
import { colors } from '../../../theme/tokens';

export const useStyles = makeStyles(() =>
  createStyles({
    calendarHeading: {
      position: 'sticky',
      top: 0,
      paddingTop: '20px',
      paddingBottom: '20px',
      left: 'auto',
      zIndex: 1,
      background: colors.bgSurface,
      color: colors.textPrimary,
    },
  }),
);
